import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

function FormStateListener({ onStateChange }) {
  const {
    errors,
    isValid,
    values,
  } = useFormikContext();

  const onStateChangeRef = useRef(onStateChange);

  useEffect(() => {
    onStateChangeRef.current = onStateChange;
  }, [onStateChange]);

  useEffect(() => {
    onStateChangeRef.current({
      errors,
      isValid,
      values,
    });
  }, [errors, isValid, values]);

  return null;
};

FormStateListener.propTypes = {
  onStateChange: PropTypes.func.isRequired,
};

export default FormStateListener;
